import { useState } from 'react'
import {
  ChordContainer,
  ChordHeader,
  ChordTitle,
  ChordDescription,
  ChordLegend,
  LegendCategories,
  LegendSwatch,
  LegendSquereContainer,
  LegendSquere,
  LegendLabel,
  Chord,
  ChordPopup,
  ChordSource,
} from './styled'
import { theme } from 'styles/theme'

const ChordDiagram = () => {
  const [popup, setPopup] = useState(false)
  const [popupText, setPopupText] = useState('')
  const [popupTextReverse, setPopupTextReverse] = useState('')

  const handleMouseOver = (e: React.MouseEvent<SVGGElement>) => {
    const target = e.currentTarget as SVGGElement
    const firstChild = target.children[0] as SVGGElement
    const secondChild = target.children[1] as SVGGElement

    firstChild.style.opacity = '1'
    secondChild.style.opacity = '1'
    setPopup(true)
    let text =
      e.currentTarget.ariaLabel +
      ': ' +
      e.currentTarget.children[1].children[0].innerHTML

    let textReverse =
      e.currentTarget.ariaLabel!.split('>>')[1] +
      '>>' +
      e.currentTarget.ariaLabel!.split('>>')[0] +
      ': ' +
      e.currentTarget.children[1].children[0].innerHTML
    setPopupText(text as string)
    setPopupTextReverse(textReverse as string)
  }
  const handleMouseOut = (e: React.MouseEvent<SVGGElement>) => {
    const target = e.currentTarget as SVGGElement
    const firstChild = target.children[0] as SVGGElement
    const secondChild = target.children[1] as SVGGElement
    firstChild.style.opacity = '0.75'
    secondChild.style.opacity = '0'
    setPopup(false)
    setPopupText('')
  }

  return (
    <ChordContainer>
      <ChordHeader>
        <ChordTitle>
          Часто насилие проявляется в нескольких формах одновременно
        </ChordTitle>
        <ChordDescription>
          Респонденты чаще всего рассказывали о случаях, когда психологическое
          насилие сопровождалось физическим
        </ChordDescription>
      </ChordHeader>
      <ChordLegend>
        <LegendCategories>
          <LegendSwatch>
            <LegendSquereContainer>
              <LegendSquere $color={'#2d1996'} />
            </LegendSquereContainer>
            <LegendLabel>Психологическое насилие</LegendLabel>
          </LegendSwatch>
          <LegendSwatch>
            <LegendSquere $color={'#0ecae3'} />
            <LegendLabel>Физическое насилие</LegendLabel>
          </LegendSwatch>
        </LegendCategories>

        <LegendCategories>
          <LegendSwatch>
            <LegendSquere $color={theme.colors.text} />
            <LegendLabel>Сексуализированное насилие</LegendLabel>
          </LegendSwatch>
          <LegendSwatch>
            <LegendSquere $color={'#ff0055'} />
            <LegendLabel>Экономическое насилие</LegendLabel>
          </LegendSwatch>
        </LegendCategories>
      </ChordLegend>
      <Chord>
        {/*width="548" height="242"*/}
        <svg viewBox="0 0 274 242">
          <defs>
            <linearGradient
              id="linkGrad-0-1"
              gradientUnits="userSpaceOnUse"
              x1="40.18349312518091"
              x2="40.61384708545813"
              y1="-74.44139706954569"
              y2="74.20748036637715"
            >
              <stop
                className="begin"
                offset="0%"
                style={{ stopColor: '#2d1996' }}
              ></stop>
              <stop
                className="end"
                offset="100%"
                style={{ stopColor: '#0ecae3' }}
              ></stop>
            </linearGradient>
            <linearGradient
              id="linkGrad-0-2"
              gradientUnits="userSpaceOnUse"
              x1="81.24378860102841"
              x2="-75.90994660844787"
              y1="-23.57289823417211"
              y2="37.335167380230416"
            >
              <stop
                className="begin"
                offset="0%"
                style={{ stopColor: '#2d1996' }}
              ></stop>
              <stop
                className="end"
                offset="100%"
                style={{ stopColor: theme.colors.text }}
              ></stop>
            </linearGradient>
            <linearGradient
              id="linkGrad-0-3"
              gradientUnits="userSpaceOnUse"
              x1="81.34443050368364"
              x2="-59.33549869091654"
              y1="23.223228531765578"
              y2="-60.295383840783934"
            >
              <stop
                className="begin"
                offset="0%"
                style={{ stopColor: '#2d1996' }}
              ></stop>
              <stop
                className="end"
                offset="100%"
                style={{ stopColor: '#ff0055' }}
              ></stop>
            </linearGradient>
            <linearGradient
              id="linkGrad-1-2"
              gradientUnits="userSpaceOnUse"
              x1="-19.64952794497905"
              x2="-84.31333132883715"
              y1="82.28080437712501"
              y2="-6.89179785258925"
            >
              <stop
                className="begin"
                offset="0%"
                style={{ stopColor: '#0ecae3' }}
              ></stop>
              <stop
                className="end"
                offset="100%"
                style={{ stopColor: theme.colors.text }}
              ></stop>
            </linearGradient>
            <linearGradient
              id="linkGrad-1-3"
              gradientUnits="userSpaceOnUse"
              x1="-49.66679066882901"
              x2="-29.99562105316452"
              y1="68.4795197271852"
              y2="-79.09802421705729"
            >
              <stop
                className="begin"
                offset="0%"
                style={{ stopColor: '#0ecae3' }}
              ></stop>
              <stop
                className="end"
                offset="100%"
                style={{ stopColor: '#ff0055' }}
              ></stop>
            </linearGradient>
            <linearGradient
              id="linkGrad-2-3"
              gradientUnits="userSpaceOnUse"
              x1="-77.61310327016847"
              x2="-10.316425194262449"
              y1="-33.651759510928876"
              y2="-83.96312338531966"
            >
              <stop
                className="begin"
                offset="0%"
                style={{ stopColor: theme.colors.text }}
              ></stop>
              <stop
                className="end"
                offset="100%"
                style={{ stopColor: '#ff0055' }}
              ></stop>
            </linearGradient>
          </defs>
          {/*<g transform="translate(274,120.046875)">*/}
          <g transform="translate(136, 120)">
            <g id="arcs-container">
              <g>
                <path
                  d="M5.452548522141223e-15,-89.046875A89.046875,89.046875,0,0,1,76.36976761215546,45.7930621615436L72.55127923154768,43.50340905346643A84.59453125,84.59453125,0,0,0,5.1799210960341625e-15,-84.59453125Z"
                  aria-roledescription="data point"
                  aria-label="Психологическое насилие"
                  style={{
                    fill: '#2d1996',
                    stroke: '#2d1996',
                    strokeWidth: '2px',
                    opacity: 1,
                  }}
                ></path>
              </g>
              <g>
                <path
                  d="M74.72509039126398,48.4304327183131A89.046875,89.046875,0,0,1,-62.647140763348155,63.28255447943664L-59.51478372518075,60.11842675546481A84.59453125,84.59453125,0,0,0,70.98883587170079,46.00891108239745Z"
                  aria-roledescription="data point"
                  aria-label="Физическое насилие"
                  style={{
                    fill: '#0ecae3',
                    stroke: '#0ecae3',
                    strokeWidth: '2px',
                    opacity: 1,
                  }}
                ></path>
              </g>
              <g>
                <path
                  d="M-64.81750711924516,61.05765077459358A89.046875,89.046875,0,0,1,-78.29630012242467,-42.4150366545265L-74.38148511630344,-40.29428482180018A84.59453125,84.59453125,0,0,0,-61.576631763282904,58.00476823586391Z"
                  aria-roledescription="data point"
                  aria-label="Сексуализированное насилие"
                  style={{
                    fill: theme.colors.text,
                    stroke: theme.colors.text,
                    strokeWidth: '2px',
                    opacity: 1,
                  }}
                ></path>
              </g>
              <g>
                <path
                  d="M-76.76834070002424,-45.12170002815306A89.046875,89.046875,0,0,1,-3.1076911204304976,-88.99263004971604L-2.9523065644089725,-84.54299854723024A84.59453125,84.59453125,0,0,0,-72.92992366502303,-42.86561502674541Z"
                  aria-roledescription="data point"
                  aria-label="Экономическое насилие"
                  style={{
                    fill: '#ff0055',
                    stroke: '#ff0055',
                    strokeWidth: '2px',
                    opacity: 1,
                  }}
                ></path>
              </g>
            </g>
            <g id="chords-container">
              <g
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                aria-roledescription="data point"
                aria-label="Психологическое насилие>>Физическое насилие"
              >
                <path
                  d="M5.12539561081275e-15,-83.7040625A83.7040625,83.7040625,0,0,1,69.9768127668437,-45.930553599951416Q0,0,70.24158496778814,45.524606755214315A83.7040625,83.7040625,0,0,1,0.4846598707764523,83.70265935926747Q0,0,5.12539561081275e-15,-83.7040625Z"
                  style={{
                    opacity: 0.75,
                    fill: "url('#linkGrad-0-1')",
                    stroke: 'rgb(255, 255, 255)',
                    strokeOpacity: 0.15,
                  }}
                ></path>
                <text
                  paintOrder="stroke"
                  style={{
                    opacity: 0,
                    fontSize: '12px',
                    fontWeight: 'bold',
                    strokeWidth: 3.6,
                  }}
                >
                  <tspan
                    x="25.93310629824962"
                    y="-48.042032015006534"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    68
                  </tspan>
                  <tspan
                    x="26.210842605617792"
                    y="47.89106985974272"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    68
                  </tspan>
                </text>
              </g>
              <g
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                aria-roledescription="data point"
                aria-label="Психологическое насилие>>Сексуализированное насилие"
              >
                <path
                  d="M69.9768127668437,-45.930553599951416A83.7040625,83.7040625,0,0,1,83.69328543491228,1.3431500713649334Q0,0,-60.92845669209046,57.394191728117974A83.7040625,83.7040625,0,0,1,-82.65284534559633,13.224115671032326Q0,0,69.9768127668437,-45.930553599951416Z"
                  style={{
                    opacity: 0.75,
                    fill: "url('#linkGrad-0-2')",
                    stroke: 'rgb(255, 255, 255)',
                    strokeOpacity: 0.15,
                  }}
                ></path>
                <text
                  paintOrder="stroke"
                  style={{
                    opacity: 0,
                    fontSize: '12px',
                    fontWeight: 'bold',
                    strokeWidth: 3.6,
                  }}
                >
                  <tspan
                    x="52.43207202767306"
                    y="-15.213174070263308"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    41
                  </tspan>
                  <tspan
                    x="-48.989785640555084"
                    y="24.094890439669765"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    41
                  </tspan>
                </text>
              </g>
              <g
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                aria-roledescription="data point"
                aria-label="Психологическое насилие>>Экономическое насилие"
              >
                <path
                  d="M83.69328543491228,1.3431500713649334A83.7040625,83.7040625,0,0,1,71.78758155542613,43.04547843185099Q0,0,-72.16224025802279,-42.41439802646388A83.7040625,83.7040625,0,0,1,-41.250991878995144,-72.83354823158751Q0,0,83.69328543491228,1.3431500713649334Z"
                  style={{
                    opacity: 0.75,
                    fill: "url('#linkGrad-0-3')",
                    stroke: 'rgb(255, 255, 255)',
                    strokeOpacity: 0.15,
                  }}
                ></path>
                <text
                  paintOrder="stroke"
                  style={{
                    opacity: 0,
                    fontSize: '12px',
                    fontWeight: 'bold',
                    strokeWidth: 3.6,
                  }}
                >
                  <tspan
                    x="52.49702300521713"
                    y="14.987508732171946"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    36
                  </tspan>
                  <tspan
                    x="-38.293181481699825"
                    y="-38.91265982192464"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    36
                  </tspan>
                </text>
              </g>
              <g
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                aria-roledescription="data point"
                aria-label="Физическое насилие>>Сексуализированное насилие"
              >
                <path
                  d="M0.4846598707764523,83.70265935926747A83.7040625,83.7040625,0,0,1,-38.253563549527,74.45156113048407Q0,0,-82.65284534559633,13.224115671032326A83.7040625,83.7040625,0,0,1,-79.40815167734395,-26.471031830887217Q0,0,0.4846598707764523,83.70265935926747Z"
                  style={{
                    opacity: 0.75,
                    fill: "url('#linkGrad-1-2')",
                    stroke: 'rgb(255, 255, 255)',
                    strokeOpacity: 0.15,
                  }}
                ></path>
                <text
                  paintOrder="stroke"
                  style={{
                    opacity: 0,
                    fontSize: '12px',
                    fontWeight: 'bold',
                    strokeWidth: 3.6,
                  }}
                >
                  <tspan
                    x="-12.681159781707603"
                    y="53.10132794006218"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    33
                  </tspan>
                  <tspan
                    x="-60"
                    y="-2"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    33
                  </tspan>
                </text>
              </g>
              <g
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                aria-roledescription="data point"
                aria-label="Физическое насилие>>Экономическое насилие"
              >
                <path
                  d="M-38.253563549527,74.45156113048407A83.7040625,83.7040625,0,0,1,-58.888312317547275,59.485601210670445Q0,0,-41.250991878995144,-72.83354823158751A83.7040625,83.7040625,0,0,1,-17.41659782558858,-81.87204772805924Q0,0,-38.253563549527,74.45156113048407Z"
                  style={{
                    opacity: 0.75,
                    fill: "url('#linkGrad-1-3')",
                    stroke: 'rgb(255, 255, 255)',
                    strokeOpacity: 0.15,
                  }}
                ></path>
                <text
                  paintOrder="stroke"
                  style={{
                    opacity: 0,
                    fontSize: '12px',
                    fontWeight: 'bold',
                    strokeWidth: 3.6,
                  }}
                >
                  <tspan
                    x="-32.053314974265476"
                    y="44.19443224624292"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    21
                  </tspan>
                  <tspan
                    x="-19.35818836930015"
                    y="-51.04726618993342"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    21
                  </tspan>
                </text>
              </g>
              <g
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                aria-roledescription="data point"
                aria-label="Сексуализированное насилие>>Экономическое насилие"
              >
                <path
                  d="M-79.40815167734395,-26.471031830887217A83.7040625,83.7040625,0,0,1,-73.59852211507919,-39.87013445525491Q0,0,-17.41659782558858,-81.87204772805924A83.7040625,83.7040625,0,0,1,-2.921229653204668,-83.65307224673309Q0,0,-79.40815167734395,-26.471031830887217Z"
                  style={{
                    opacity: 0.75,
                    fill: "url('#linkGrad-2-3')",
                    stroke: 'rgb(255, 255, 255)',
                    strokeOpacity: 0.15,
                  }}
                ></path>
                <text
                  paintOrder="stroke"
                  style={{
                    opacity: 0,
                    fontSize: '12px',
                    fontWeight: 'bold',
                    strokeWidth: 2,
                    fill: 'white',
                  }}
                >
                  <tspan
                    x="-50.08894699552685"
                    y="-21.717740013328477"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    12
                  </tspan>
                  <tspan
                    x="-9"
                    y="-54.187041358036254"
                    style={{ textAnchor: 'middle', fill: 'white' }}
                  >
                    12
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </svg>
      </Chord>
      <ChordPopup style={{ opacity: popup ? 1 : 0 }}>
        {popupText}
        <br />
        {popupTextReverse}
      </ChordPopup>
      <ChordSource>
        Источник: Результаты опросника проекта "Голоса смелых" в странах
        Центральной Азии
      </ChordSource>
    </ChordContainer>
  )
}
export default ChordDiagram
